
export interface IChangeTypePermission {
    name: string;
    benefit: {
        add: boolean;
        modify_deactivate: boolean;
        add_nonstandard: boolean;
    },
    canAddAccountReceivable: boolean;
    canDeactivateAccountReceivable: boolean;
    feesAndPremium: {
        import: boolean;
        export: boolean;
        add: boolean;
        modify_deactivate: boolean;
    },
    stopLoss: {
        add: boolean;
        modify_deactivate: boolean;
    },
    plan: {
        add: boolean;
        modify_deactivate: boolean;
        link_benefit: boolean;
        link_feesandpremium: boolean;
    };
    canAddGroupConfigurationNonstandard: boolean;
    groupStructure: {
        import: boolean;
        export: boolean;
        groupNumber: {
            add: boolean;
            modify_groupnumber: boolean;
            modify_status: boolean;
            modify_deactivate: boolean;
            link_ces: boolean;
            link_plan: boolean;
            link_accountsreceivable: boolean;
            link_stoploss: boolean;
        },
        ces: {
            add: boolean;
            modify_cesnumber: boolean;
            modify_deactivate: boolean;
        },
        department: {
            add: boolean;
            modify: boolean;
            modify_deactivate: boolean;
            link_ces: boolean;
        }
    };
}

export const ChangeTypePermissions: Record<number, IChangeTypePermission> = {
    0: {
        name: "Default",
        benefit: {
            add: false,
            modify_deactivate: false,
            add_nonstandard: false,
        },
        canAddAccountReceivable: false,
        canDeactivateAccountReceivable: false,
        feesAndPremium: {
            import: false,
            export: true,
            add: false,
            modify_deactivate: false,
        },
        stopLoss: {
            add: false,
            modify_deactivate: false,
        },
        plan: {
            add: false,
            modify_deactivate: false,
            link_benefit: false,
            link_feesandpremium: false,
        },
        canAddGroupConfigurationNonstandard: false,
        groupStructure: {
            import: false,
            export: true,
            groupNumber: {
                add: false,
                modify_groupnumber: false,
                modify_status: false,
                modify_deactivate: false,
                link_ces: false,
                link_plan: false,
                link_stoploss: false,
                link_accountsreceivable: false,
            },
            ces: {
                add: false,
                modify_cesnumber: false,
                modify_deactivate: false,
            },
            department: {
                add: false,
                modify: false,
                modify_deactivate: false,
                link_ces: false,
            }
        }

    },

    // Admin Over Ride
    1: {
        name: "Admin Mode",
        benefit: {
            add: true,
            modify_deactivate: true,
            add_nonstandard: true,
        },
        canAddAccountReceivable: true,
        canDeactivateAccountReceivable: true,
        feesAndPremium: {
            import: false,
            export: true,
            add: true,
            modify_deactivate: true,
        },
        stopLoss: {
            add: true,
            modify_deactivate: true,
        },
        plan: {
            add: true,
            modify_deactivate: true,
            link_benefit: true,
            link_feesandpremium: true,
        },
        canAddGroupConfigurationNonstandard: true,
        groupStructure: {
            import: true,
            export: true,
            groupNumber: {
                add: true,
                modify_groupnumber: true,
                modify_status: true,
                modify_deactivate: true,
                link_ces: true,
                link_plan: true,
                link_stoploss: true,
                link_accountsreceivable: true,
            },
            ces: {
                add: true,
                modify_cesnumber: true,
                modify_deactivate: true,
            },
            department: {
                add: true,
                modify: true,
                modify_deactivate: true,
                link_ces: true,
            }
        }
    },
    808900002: {
        name: "Initial Setup",
        benefit: {
            add: true,
            modify_deactivate: true,
            add_nonstandard: true,
        },
        canAddAccountReceivable: true,
        canDeactivateAccountReceivable: true,
        feesAndPremium: {
            import: false,
            export: true,
            add: true,
            modify_deactivate: true,
        },
        stopLoss: {
            add: true,
            modify_deactivate: true,
        },
        plan: {
            add: true,
            modify_deactivate: true,
            link_benefit: true,
            link_feesandpremium: true,
        },
        canAddGroupConfigurationNonstandard: true,
        groupStructure: {
            import: true,
            export: true,
            groupNumber: {
                add: true,
                modify_groupnumber: true,
                modify_status: true,
                modify_deactivate: true,
                link_ces: true,
                link_plan: true,
                link_stoploss: true,
                link_accountsreceivable: true,
            },
            ces: {
                add: true,
                modify_cesnumber: true,
                modify_deactivate: true,
            },
            department: {
                add: true,
                modify: true,
                modify_deactivate: true,
                link_ces: true,
            }
        }
    },
    808900001: {
        name: "Comprehensive Renewal",
        benefit: {
            add: true,
            modify_deactivate: true,
            add_nonstandard: true,
        },
        canAddAccountReceivable: true,
        canDeactivateAccountReceivable: true,
        feesAndPremium: {
            import: true,
            export: true,
            add: true,
            modify_deactivate: true,
        },
        stopLoss: {
            add: true,
            modify_deactivate: true,
        },
        plan: {
            add: true,
            modify_deactivate: true,
            link_benefit: true,
            link_feesandpremium: true,
        },
        canAddGroupConfigurationNonstandard: true,
        groupStructure: {
            import: true,
            export: true,
            groupNumber: {
                add: true,
                modify_groupnumber: true,
                modify_status: true,
                modify_deactivate: true,
                link_ces: true,
                link_plan: true,
                link_stoploss: true,
                link_accountsreceivable: true,
            },
            ces: {
                add: true,
                modify_cesnumber: true,
                modify_deactivate: true,
            },
            department: {
                add: true,
                modify: true,
                modify_deactivate: true,
                link_ces: true,
            }
        }
    },
    808900010: {
        name: "Benefit Renewal",
        benefit: {
            add: true,
            modify_deactivate: true,
            add_nonstandard: true,
        },
        canAddAccountReceivable: false,
        canDeactivateAccountReceivable: false,
        feesAndPremium: {
            import: false,
            export: true,
            add: false,
            modify_deactivate: false,
        },
        stopLoss: {
            add: false,
            modify_deactivate: false,
        },
        plan: {
            add: true,
            modify_deactivate: true,
            link_benefit: true,
            link_feesandpremium: false,
        },
        canAddGroupConfigurationNonstandard: true,
        groupStructure: {
            import: true,
            export: true,
            groupNumber: {
                add: true,
                modify_groupnumber: true,
                modify_status: true,
                modify_deactivate: true,
                link_ces: true,
                link_plan: true,
                link_stoploss: false,
                link_accountsreceivable: false,
            },
            ces: {
                add: true,
                modify_cesnumber: true,
                modify_deactivate: true,
            },
            department: {
                add: true,
                modify: true,
                modify_deactivate: true,
                link_ces: true,
            }
        }
    },
    808900011: {
        name: "Financial Renewal",
        benefit: {
            add: false,
            modify_deactivate: false,
            add_nonstandard: false,
        },
        canAddAccountReceivable: true,
        canDeactivateAccountReceivable: true,
        feesAndPremium: {
            import: true,
            export: true,
            add: true,
            modify_deactivate: true,
        },
        stopLoss: {
            add: true,
            modify_deactivate: true,
        },
        plan: {
            add: false,
            modify_deactivate: false,
            link_benefit: false,
            link_feesandpremium: true,
        },
        canAddGroupConfigurationNonstandard: true,
        groupStructure: {
            import: false,
            export: true,
            groupNumber: {
                add: false,
                modify_groupnumber: false,
                modify_status: false,
                modify_deactivate: false,
                link_ces: true,
                link_plan: false,
                link_stoploss: true,
                link_accountsreceivable: true,
            },
            ces: {
                add: false,
                modify_cesnumber: false,
                modify_deactivate: false,
            },
            department: {
                add: false,
                modify: false,
                modify_deactivate: false,
                link_ces: false,
            }
        }
    },
    808900004: {
        name: "Comprehensive Change",
        benefit: {
            add: true,
            modify_deactivate: true,
            add_nonstandard: true,
        },
        canAddAccountReceivable: true,
        canDeactivateAccountReceivable: true,
        feesAndPremium: {
            import: true,
            export: true,
            add: true,
            modify_deactivate: true,
        },
        stopLoss: {
            add: true,
            modify_deactivate: true,
        },
        plan: {
            add: true,
            modify_deactivate: true,
            link_benefit: true,
            link_feesandpremium: true,
        },
        canAddGroupConfigurationNonstandard: true,
        groupStructure: {
            import: true,
            export: true,
            groupNumber: {
                add: true,
                modify_groupnumber: true,
                modify_status: true,
                modify_deactivate: true,
                link_ces: true,
                link_plan: true,
                link_stoploss: true,
                link_accountsreceivable: true,
            },
            ces: {
                add: true,
                modify_cesnumber: true,
                modify_deactivate: true,
            },
            department: {
                add: true,
                modify: true,
                modify_deactivate: true,
                link_ces: true,
            }
        }
    },
    808900000: {
        name: "Benefit Change",
        benefit: {
            add: true,
            modify_deactivate: true,
            add_nonstandard: true,
        },
        canAddAccountReceivable: false,
        canDeactivateAccountReceivable: false,
        feesAndPremium: {
            import: false,
            export: true,
            add: false,
            modify_deactivate: false,
        },
        stopLoss: {
            add: false,
            modify_deactivate: false,
        },
        plan: {
            add: true,
            modify_deactivate: true,
            link_benefit: true,
            link_feesandpremium: false,
        },
        canAddGroupConfigurationNonstandard: true,
        groupStructure: {
            import: true,
            export: true,
            groupNumber: {
                add: true,
                modify_groupnumber: true,
                modify_status: true,
                modify_deactivate: true,
                link_ces: true,
                link_plan: true,
                link_stoploss: false,
                link_accountsreceivable: false,
            },
            ces: {
                add: true,
                modify_cesnumber: true,
                modify_deactivate: true,
            },
            department: {
                add: true,
                modify: true,
                modify_deactivate: true,
                link_ces: true,
            }
        }
    },
    808900006: {
        name: "Financial Change",
        benefit: {
            add: false,
            modify_deactivate: false,
            add_nonstandard: false,
        },
        canAddAccountReceivable: true,
        canDeactivateAccountReceivable: true,
        feesAndPremium: {
            import: true,
            export: true,
            add: true,
            modify_deactivate: true,
        },
        stopLoss: {
            add: true,
            modify_deactivate: true,
        },
        plan: {
            add: false,
            modify_deactivate: false,
            link_benefit: false,
            link_feesandpremium: true,
        },
        canAddGroupConfigurationNonstandard: true,
        groupStructure: {
            import: false,
            export: true,
            groupNumber: {
                add: false,
                modify_groupnumber: false,
                modify_status: false,
                modify_deactivate: false,
                link_ces: true,
                link_plan: false,
                link_stoploss: true,
                link_accountsreceivable: true,
            },
            ces: {
                add: false,
                modify_cesnumber: false,
                modify_deactivate: false,
            },
            department: {
                add: false,
                modify: false,
                modify_deactivate: false,
                link_ces: false,
            }
        }
    },
    808900009: {
        name: "Stop Loss",
        benefit: {
            add: false,
            modify_deactivate: false,
            add_nonstandard: false,
        },
        canAddAccountReceivable: false,
        canDeactivateAccountReceivable: false,
        feesAndPremium: {
            import: false,
            export: true,
            add: false,
            modify_deactivate: false,
        },
        stopLoss: {
            add: true,
            modify_deactivate: true,
        },
        plan: {
            add: false,
            modify_deactivate: false,
            link_benefit: false,
            link_feesandpremium: false,
        },
        canAddGroupConfigurationNonstandard: false,
        groupStructure: {
            import: false,
            export: true,
            groupNumber: {
                add: false,
                modify_groupnumber: false,
                modify_status: false,
                modify_deactivate: false,
                link_ces: true,
                link_plan: false,
                link_stoploss: true,
                link_accountsreceivable: false,
            },
            ces: {
                add: false,
                modify_cesnumber: false,
                modify_deactivate: false,
            },
            department: {
                add: false,
                modify: false,
                modify_deactivate: false,
                link_ces: false,
            }
        }
    },
    808900003: {
        name: "Administrative Change",
        benefit: {
            add: false,
            modify_deactivate: false,
            add_nonstandard: false,
        },
        canAddAccountReceivable: false,
        canDeactivateAccountReceivable: false,
        feesAndPremium: {
            import: false,
            export: true,
            add: false,
            modify_deactivate: false,
        },
        stopLoss: {
            add: false,
            modify_deactivate: false,
        },
        plan: {
            add: false,
            modify_deactivate: false,
            link_benefit: false,
            link_feesandpremium: false,
        },
        canAddGroupConfigurationNonstandard: false,
        groupStructure: {
            import: false,
            export: true,
            groupNumber: {
                add: false,
                modify_groupnumber: false,
                modify_status: false,
                modify_deactivate: false,
                link_ces: true,
                link_plan: false,
                link_stoploss: false,
                link_accountsreceivable: false,
            },
            ces: {
                add: false,
                modify_cesnumber: true,
                modify_deactivate: true,
            },
            department: {
                add: false,
                modify: false,
                modify_deactivate: false,
                link_ces: true,
            }
        }
    },
    808900005: {
        name: "MNIL  Initial Setup Continuation",
        benefit: {
            add: true,
            modify_deactivate: true,
            add_nonstandard: true,
        },
        canAddAccountReceivable: true,
        canDeactivateAccountReceivable: true,
        feesAndPremium: {
            import: false,
            export: true,
            add: true,
            modify_deactivate: true,
        },
        stopLoss: {
            add: true,
            modify_deactivate: true,
        },
        plan: {
            add: true,
            modify_deactivate: true,
            link_benefit: true,
            link_feesandpremium: true,
        },
        canAddGroupConfigurationNonstandard: true,
        groupStructure: {
            import: true,
            export: true,
            groupNumber: {
                add: true,
                modify_groupnumber: true,
                modify_status: true,
                modify_deactivate: true,
                link_ces: true,
                link_plan: true,
                link_stoploss: true,
                link_accountsreceivable: true,
            },
            ces: {
                add: true,
                modify_cesnumber: true,
                modify_deactivate: true,
            },
            department: {
                add: true,
                modify: true,
                modify_deactivate: true,
                link_ces: true,
            }
        }
    },
    808900008: {
        name: "MNIL  Renewal Continuation",
        benefit: {
            add: true,
            modify_deactivate: true,
            add_nonstandard: true,
        },
        canAddAccountReceivable: false,
        canDeactivateAccountReceivable: false,
        feesAndPremium: {
            import: false,
            export: true,
            add: false,
            modify_deactivate: false,
        },
        stopLoss: {
            add: false,
            modify_deactivate: false,
        },
        plan: {
            add: true,
            modify_deactivate: true,
            link_benefit: true,
            link_feesandpremium: false,
        },
        canAddGroupConfigurationNonstandard: true,
        groupStructure: {
            import: true,
            export: true,
            groupNumber: {
                add: true,
                modify_groupnumber: true,
                modify_status: true,
                modify_deactivate: true,
                link_ces: true,
                link_plan: true,
                link_stoploss: false,
                link_accountsreceivable: false,
            },
            ces: {
                add: true,
                modify_cesnumber: true,
                modify_deactivate: true,
            },
            department: {
                add: true,
                modify: true,
                modify_deactivate: true,
                link_ces: true,
            }
        }
    },
    808900007: {
        name: "MNIL  Benefit Change Continuation",
        benefit: {
            add: true,
            modify_deactivate: true,
            add_nonstandard: true,
        },
        canAddAccountReceivable: false,
        canDeactivateAccountReceivable: false,
        feesAndPremium: {
            import: false,
            export: true,
            add: false,
            modify_deactivate: false,
        },
        stopLoss: {
            add: false,
            modify_deactivate: false,
        },
        plan: {
            add: true,
            modify_deactivate: true,
            link_benefit: true,
            link_feesandpremium: false,
        },
        canAddGroupConfigurationNonstandard: true,
        groupStructure: {
            import: true,
            export: true,
            groupNumber: {
                add: true,
                modify_groupnumber: true,
                modify_status: true,
                modify_deactivate: true,
                link_ces: true,
                link_plan: true,
                link_stoploss: false,
                link_accountsreceivable: false,
            },
            ces: {
                add: true,
                modify_cesnumber: true,
                modify_deactivate: true,
            },
            department: {
                add: true,
                modify: true,
                modify_deactivate: true,
                link_ces: true,
            }
        }
    },
    808900013: {
        name: "MNIL Comprehensive Change Continuation",
        benefit: {
            add: true,
            modify_deactivate: true,
            add_nonstandard: true,
        },
        canAddAccountReceivable: true,
        canDeactivateAccountReceivable: true,
        feesAndPremium: {
            import: false,
            export: true,
            add: true,
            modify_deactivate: true,
        },
        stopLoss: {
            add: true,
            modify_deactivate: true,
        },
        plan: {
            add: true,
            modify_deactivate: true,
            link_benefit: true,
            link_feesandpremium: true,
        },
        canAddGroupConfigurationNonstandard: true,
        groupStructure: {
            import: true,
            export: true,
            groupNumber: {
                add: true,
                modify_groupnumber: true,
                modify_status: true,
                modify_deactivate: true,
                link_ces: true,
                link_plan: true,
                link_stoploss: true,
                link_accountsreceivable: true,
            },
            ces: {
                add: true,
                modify_cesnumber: true,
                modify_deactivate: true,
            },
            department: {
                add: true,
                modify: true,
                modify_deactivate: true,
                link_ces: true,
            }
        }
    },
    808900014: {
        name: "MNIL  Comprehensive Renewal Continuation",
        benefit: {
            add: true,
            modify_deactivate: true,
            add_nonstandard: true,
        },
        canAddAccountReceivable: true,
        canDeactivateAccountReceivable: true,
        feesAndPremium: {
            import: false,
            export: true,
            add: true,
            modify_deactivate: true,
        },
        stopLoss: {
            add: true,
            modify_deactivate: true,
        },
        plan: {
            add: true,
            modify_deactivate: true,
            link_benefit: true,
            link_feesandpremium: true,
        },
        canAddGroupConfigurationNonstandard: true,
        groupStructure: {
            import: true,
            export: true,
            groupNumber: {
                add: true,
                modify_groupnumber: true,
                modify_status: true,
                modify_deactivate: true,
                link_ces: true,
                link_plan: true,
                link_stoploss: true,
                link_accountsreceivable: true,
            },
            ces: {
                add: true,
                modify_cesnumber: true,
                modify_deactivate: true,
            },
            department: {
                add: true,
                modify: true,
                modify_deactivate: true,
                link_ces: true,
            }
        }
    },
    808900012: {
        name: "PSA Change",
        benefit: {
            add: false,
            modify_deactivate: false,
            add_nonstandard: false,
        },
        canAddAccountReceivable: false,
        canDeactivateAccountReceivable: false,
        feesAndPremium: {
            import: false,
            export: true,
            add: false,
            modify_deactivate: false,
        },
        stopLoss: {
            add: false,
            modify_deactivate: false,
        },
        plan: {
            add: false,
            modify_deactivate: false,
            link_benefit: false,
            link_feesandpremium: false,
        },
        canAddGroupConfigurationNonstandard: false,
        groupStructure: {
            import: false,
            export: true,
            groupNumber: {
                add: false,
                modify_groupnumber: false,
                modify_status: false,
                modify_deactivate: false,
                link_ces: true,
                link_plan: false,
                link_stoploss: false,
                link_accountsreceivable: false,
            },
            ces: {
                add: false,
                modify_cesnumber: false,
                modify_deactivate: false,
            },
            department: {
                add: false,
                modify: false,
                modify_deactivate: false,
                link_ces: false,
            }
        }
    },
    808900015: {
        name: "Post Cancel Update",
        benefit: {
            add: false,
            modify_deactivate: false,
            add_nonstandard: false,
        },
        canAddAccountReceivable: false,
        canDeactivateAccountReceivable: false,
        feesAndPremium: {
            import: false,
            export: true,
            add: false,
            modify_deactivate: false,
        },
        stopLoss: {
            add: false,
            modify_deactivate: false,
        },
        plan: {
            add: false,
            modify_deactivate: false,
            link_benefit: false,
            link_feesandpremium: false,
        },
        canAddGroupConfigurationNonstandard: false,
        groupStructure: {
            import: false,
            export: true,
            groupNumber: {
                add: false,
                modify_groupnumber: false,
                modify_status: false,
                modify_deactivate: false,
                link_ces: true,
                link_plan: false,
                link_stoploss: false,
                link_accountsreceivable: false,
            },
            ces: {
                add: false,
                modify_cesnumber: false,
                modify_deactivate: false,
            },
            department: {
                add: false,
                modify: false,
                modify_deactivate: false,
                link_ces: false,
            }
        }
    },

}
